import React from 'react';
import classNames from "classnames";

import { useChasersContext, useMapContext, useQuery } from "hooks";

import { Video } from "components";
import { CloseSVG } from "assets/icons";

const LiveStreamPanel = ({ children, liveReplay, handleSetUpdate }) => {
  const { updateID} = useQuery();
  const { streamingChaserID, setStreamingChaserID } = useMapContext();
  const { chasers } = useChasersContext();

  const closeLiveStreaming = () => setStreamingChaserID(null);

  // Chase replays pass in their own player for the recorded stream and their
  // own close handler. The live-chaser check below would hide it, because
  // nobody is streaming live on a replay, so recorded streams never showed.
  if (liveReplay) {
    return (
      <div className="UpdatePanel LiveStreamPanel replay">
        <div className="Update__meta">
          <button className="Update__close" onClick={() => handleSetUpdate && handleSetUpdate()}>
            <CloseSVG/>
          </button>
          <div>
            <figure>{children}</figure>
          </div>
        </div>
      </div>
    );
  }

  if (!(streamingChaserID && chasers && chasers[streamingChaserID]?.live) || updateID) return null;

  return (
    <div className={classNames('UpdatePanel LiveStreamPanel', { 'replay': liveReplay })}>
      <div className="Update__meta">
        <button className="Update__close" onClick={closeLiveStreaming}>
          <CloseSVG/>
        </button>
        <div>
          <figure>{
              children ||
              <Video
                key={chasers[streamingChaserID].live}
                playback_id={chasers[streamingChaserID].live}
                video_id={chasers[streamingChaserID].live}
                video_title={`${chasers[streamingChaserID].name} Livestream`}
                isLivestream={streamingChaserID}
              />
            }
          </figure>
        </div>
      </div>
    </div>
  );
}

export default LiveStreamPanel;
